<template>
  <div class="general-tab">
    <div>
      <b-checkbox
        class="general-tab__title mt-0"
        :checked="isAllFieldsSelected('installationData')"
        @change="toggleAll($event, 'installationData')"
      >
        {{ $t('reports.installation-data') }}
      </b-checkbox>
    </div>
    <b-checkbox-group
      class="general-tab__checkbox-group"
      v-model="selectedFieldsProxy"
      :options="fields.installationData"
    />
    <div>
      <b-checkbox
        class="general-tab__title"
        :checked="isAllFieldsSelected('assetRegistrationData')"
        @change="toggleAll($event, 'assetRegistrationData')"
      >
        {{ $t('reports.asset-registration-data') }}
      </b-checkbox>
    </div>
    <b-checkbox-group
      class="general-tab__checkbox-group"
      v-model="selectedFieldsProxy"
      :options="fields.assetRegistrationData"
    />
  </div>
</template>

<script>
import generalTabFields from '@/domain/data/generalPanel/reports/additionalFields/generalTabFields';
import additionalFieldsTabMixin from '@/domain/data/generalPanel/reports/additionalFields/additionalFieldsTabMixin';

export default {
  name: 'GeneralTab',
  mixins: [additionalFieldsTabMixin],
  props: {
    selectedFields: {
      type: Array,
      default: () => ([]),
    },
  },
  data: vm => ({
    fields: generalTabFields(vm),
  }),
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/variables"

  .general-tab
    &__title
      background-color: var(--color-background-dark)
      color: var(--font-color-primary)
      padding-left: 30px
      max-height: unset
      height: 30px
      display: flex
      align-items: center
      margin: 10px 0
    &__checkbox-group
      margin-left: 9px
      ::v-deep
        .custom-control.custom-control-inline.custom-checkbox
          width: 230px
        .custom-control-label
          font-weight: normal
        > div
          min-height: 50px
          max-height: unset
          align-items: center
</style>
